export class AcaoEixo {
    id: number =  0;
    numero: number =  0;
    descricao: string = ""
}